import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileUndefined.tsx
const IconFileUndefined = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h3v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#b4a9a8",
			fillRule: "evenodd",
			d: "M15 10a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1zm3.494 3.692v-.918q.474-.018.708-.156.24-.144.24-.48v-.084q0-.228-.138-.348a.5.5 0 0 0-.348-.12.55.55 0 0 0-.39.144.74.74 0 0 0-.204.366l-.732-.306q.054-.18.156-.348a1.1 1.1 0 0 1 .264-.306q.168-.138.396-.222.234-.084.54-.084.312 0 .57.09t.444.252.282.39q.102.228.102.504a1.2 1.2 0 0 1-.312.816q-.144.15-.336.246a1.4 1.4 0 0 1-.402.132v.432zm.018 1.338q.126.132.414.132t.408-.132a.45.45 0 0 0 .126-.324v-.144a.45.45 0 0 0-.126-.324q-.12-.132-.408-.132t-.414.132a.46.46 0 0 0-.12.324v.144q0 .192.12.324",
			clipRule: "evenodd"
		})
	]
});
var IconFileUndefined_default = forwardRef(IconFileUndefined);
//#endregion
export { IconFileUndefined_default as default };
